import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, func, node, oneOf, oneOfType, string, number, shape } from 'prop-types';
import { Container, Input, Label, Text } from './chip.styles';

const Chip = _ref => {
  let {
    as,
    checked,
    clickable,
    startIcon,
    children,
    autoSize,
    endIcon,
    value,
    color,
    gridGap,
    size,
    name,
    type,
    id,
    bg,
    scales,
    onChange,
    onClick,
    hasBorder,
    textMaxWidth
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "checked", "clickable", "startIcon", "children", "autoSize", "endIcon", "value", "color", "gridGap", "size", "name", "type", "id", "bg", "scales", "onChange", "onClick", "hasBorder", "textMaxWidth"]);

  const typeAs = clickable ? as || 'a' : as || 'div';
  const labelProps = clickable && {
    onChange
  };

  const onChangeInput = event => {
    var _event$target, _event$target2;

    onChange({
      value: event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value,
      selected: event == null ? void 0 : (_event$target2 = event.target) == null ? void 0 : _event$target2.checked
    });
  };

  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    as: typeAs,
    "data-testid": "chip-container"
  }), type && /*#__PURE__*/React.createElement(Input, {
    "data-testid": "chip-input",
    checked: checked,
    onChange: onChangeInput,
    value: value,
    type: type,
    name: name,
    bg: bg,
    scales: scales,
    id: id
  }), /*#__PURE__*/React.createElement(Label, _extends({
    "data-testid": "chip-label",
    onClick: onClick,
    gridGap: gridGap,
    clickable: clickable,
    startIcon: startIcon,
    autoSize: autoSize,
    endIcon: endIcon,
    size: size,
    htmlFor: id,
    bg: bg,
    type: type,
    hasBorder: hasBorder,
    scales: scales
  }, props, labelProps), startIcon, /*#__PURE__*/React.createElement(Text, {
    autoSize: autoSize,
    clickable: clickable,
    color: color,
    bg: bg,
    textMaxWidth: textMaxWidth
  }, children), endIcon));
};

process.env.NODE_ENV !== "production" ? Chip.propTypes = {
  scales: shape({}),
  type: oneOf(['checkbox', 'radio', '']),
  size: oneOf(['small', 'medium']),
  checked: bool,
  startIcon: node,
  clickable: bool,
  autoSize: bool,
  hasBorder: bool,
  children: node,
  endIcon: node,
  onChange: func,
  onClick: func,
  color: string,
  gridGap: number,
  fontSize: oneOfType([string, number]),
  fontWeight: oneOfType([string, number]),
  value: string,
  name: string,
  id: string,
  bg: string,
  as: string,
  justify: oneOfType(['start', 'center', 'end', 'space-around', 'space-between', '']),
  minWidth: string,
  maxWidth: string,
  textMaxWidth: string
} : void 0;
Chip.defaultProps = {
  onChange: () => {},
  onClick: () => {},
  type: '',
  clickable: false,
  startIcon: null,
  size: 'medium',
  children: null,
  gridGap: 2,
  bg: '',
  fontSize: 0,
  fontWeight: 'regular',
  hasBorder: false,
  endIcon: null,
  value: '',
  color: '',
  name: '',
  id: '',
  justify: 'center',
  minWidth: '66px',
  maxWidth: '144px',
  textMaxWidth: '60%'
};
export default Chip;